/*eslint-disable*/export const messages=JSON.parse("{\"forms.field.label.optional\":[\"(valinnainen)\"],\"forms.validation.mandatoryField\":[\"Pakollinen\"]}");